/**
 * Palabras que NO son el slug de una empresa.
 *
 * ⚠️ Está duplicada en `packages/backend/src/utils/reserved-slugs.ts` a
 * propósito: son dos paquetes sin código compartido. Si se agrega una ruta
 * pública nueva, hay que agregarla en LOS DOS lados — el backend impide
 * registrar una empresa con ese nombre, y esta lista impide que la URL se
 * interprete mal.
 */
export const SLUGS_RESERVADOS = [
  'login',
  'register',
  'invitacion',
  'platform',
  'plataforma',
  'soluciones',
  'track',
  'invite',
  'forgot-password',
  'reset-password',
  'terms',
  'privacy',
  'contract',
  'legal-notice',
  'acceptable-use',
  'data-processing',
  'why-prixia',
  'resources',
  'case-studies',
  'admin',
  'api',
  'portales',
  // Vault 346 (D1): la landing nueva vive en `/inicio-nuevo` hasta que reemplace a `/`.
  'inicio-nuevo',
  // Recorrido DEV 3-nov (vault 350): rutas públicas que, abiertas directo (correo, QR),
  // caían en `/<palabra>/login` por leerse como empresa. Incluye las retiradas en L0, que
  // redirigen al inicio.
  'contact',
  'about',
  'video',
  'sales-pdf',
  'manual-curso',
  'docs',
  'go-to-market',
  'gtm',
  'roadmap',
  'blog',
  'careers',
] as const;

/**
 * Rutas internas de desarrollo (`/_ui`, el catálogo de componentes). No van en
 * la lista de arriba ni en la del backend: el alta de empresa sólo acepta
 * minúsculas, números y guiones (`admin.routes.ts`), así que una dirección con
 * guion bajo nunca puede ser una empresa.
 */
const RUTAS_INTERNAS = ['_ui'];

const reservadas = new Set<string>([...SLUGS_RESERVADOS, ...RUTAS_INTERNAS]);

export type PortalDeLaUrl = { tipo: 'publico' } | { tipo: 'empresa'; slug: string };

/**
 * Qué significa el primer segmento de la URL.
 *
 * Es una función pura para poder probarla sin navegador y sin router: la
 * decisión de "esto es una empresa o una página pública" es la más fácil de
 * romper sin darse cuenta, y la más caro de depurar en vivo.
 */
export function resolverPortalDeLaUrl(pathname: string): PortalDeLaUrl {
  const primero = pathname.split('/').filter(Boolean)[0];
  if (!primero) return { tipo: 'publico' };
  const normalizado = primero.toLowerCase();
  if (reservadas.has(normalizado)) return { tipo: 'publico' };
  return { tipo: 'empresa', slug: normalizado };
}
